import {useQuery} from '@apollo/client';
import React, {useMemo} from 'react';
import {getBusinessUnitsQuery} from '../../contexts/useAuthContext';
import {GetBusinessUnits} from '../../schema-types/GetBusinessUnits';
import AutoField, {ActionType, SelectAutocompleteField} from '../AutoForm/AutoFieldNew';

export const BusinessUnitSearch: React.FC = () => {
  const {data, loading} = useQuery<GetBusinessUnits>(getBusinessUnitsQuery);
  const searchField = useMemo(() => {
    const field: SelectAutocompleteField = {
      type: ActionType.selectAutocomplete,
      id: 'businessUnitId',
      label: 'Business Unit',
      fullWidth: true,
      size: 'medium',
      options:
        data?.businessUnits?.map((x) => ({
          label: x!.name!,
          value: x!.id as any,
          group: x!.partnershipType!,
        })) || [],
      loading,
    };
    return field;
  }, [data]);

  return <AutoField field={searchField} />;
};
